module.exports = __webpack_public_path__ + "img/7.dd92350.jpg";